export const defaultSupplierConfig = {
  supplierCompanyName: '',
  logo: {
    small: '',
    large: '',
    alt: '',
  },
  chatlio: {
    widgetId: '',
    widgetTitle: '',
  },
  auth0: {
    clientId: '',
  },
  misc: {
    deliveryComment: '',
    facilityTypes: [],
  },
  clientName: 'medigi',
  clientNameSpace: 'medigi',
};

export const medigi = {
  supplierCompanyName: 'Medigi',
  logo: {
    small: '',
    large: '',
    alt: '',
  },
  chatlio: {
    widgetId: '',
    widgetTitle: '',
    logo: '',
  },
  auth0: {
    clientId: 'YqIMP5zpkB3zU23e31fRXbZ6vDVEUdP9',
  },
  misc: {
    enableExpeditedShipping: false,
    deliveryComment: '',
    facilityTypes: [
      'Ambulatory Center',
      'Central Fill',
      'Community Oncology',
      'Compounding',
      'Correctional Facility',
      'Infusion',
      'Inpatient',
      'Long Term Care',
      'Mail Order',
      'Outpatient',
      'Physician Office',
      'Retail',
      'Specialty',
      'Surgery Center',
      'Other',
    ],
  },
  clientName: 'medigi', // replace with the actual client name of your local env
  clientNameSpace: 'medigi',
};

export const eschelon = {
  supplierCompanyName: 'Eschelon',
  logo: {
    small:
      'https://medigi-client-images.s3.us-west-2.amazonaws.com/hydra/echelon/e-logo.svg',
    large:
      'https://medigi-client-images.s3.us-west-2.amazonaws.com/hydra/GC_oncology/cg-cutout.png',
    alt: '',
  },
  chatlio: {
    widgetId: '',
    widgetTitle: '',
    logo: '',
  },
  auth0: {
    clientId: 'sZ2oYnLQRCsq0FiojEsvz2v919fuIFME',
  },
  misc: {
    enableExpeditedShipping: false,
    deliveryComment:
      'Orders received M-Th by 12pm CST will ship for next day delivery. All other orders will ship within 48 business hours.',
    facilityTypes: [
      'Ambulatory Center',
      'Central Fill',
      'Community Oncology',
      'Compounding',
      'Correctional Facility',
      'Infusion',
      'Inpatient',
      'Long Term Care',
      'Mail Order',
      'Outpatient',
      'Physician Office',
      'Retail',
      'Specialty',
      'Surgery Center',
      'Other',
    ],
  },
  clientName: 'eschelon',
  clientNameSpace: 'eschelon',
};

export const chimera = {
  supplierCompanyName: 'Medigi',
  logo: {
    small: '',
    large: '',
    alt: '',
  },
  chatlio: {
    widgetId: '',
    widgetTitle: '',
    logo: '',
  },
  auth0: {
    clientId: 'V8A4kBQ4WOd9Y0RA7w61fOIbOmwyoowh',
  },
  misc: {
    enableExpeditedShipping: false,
    deliveryComment: 'delivery comment',
    facilityTypes: [
      'Special Localhost only option :)',
      'Ambulatory Center',
      'Central Fill',
      'Community Oncology',
      'Compounding',
      'Correctional Facility',
      'Infusion',
      'Inpatient',
      'Long Term Care',
      'Mail Order',
      'Outpatient',
      'Physician Office',
      'Retail',
      'Specialty',
      'Surgery Center',
      'Other',
    ],
  },
  clientName: 'chimera', // replace with the actual client name of your local env
  clientNameSpace: 'chimera',
};

export const medigiStaging = {
  supplierCompanyName: 'Medigi',
  logo: {
    small: '',
    large: '',
    alt: '',
  },
  chatlio: {
    widgetId: '',
    widgetTitle: '',
    logo: '',
  },
  auth0: {
    clientId: 'V8A4kBQ4WOd9Y0RA7w61fOIbOmwyoowh',
  },
  misc: {
    enableExpeditedShipping: false,
    deliveryComment: 'delivery comment',
    facilityTypes: [
      'Special Localhost only option :)',
      'Ambulatory Center',
      'Central Fill',
      'Community Oncology',
      'Compounding',
      'Correctional Facility',
      'Infusion',
      'Inpatient',
      'Long Term Care',
      'Mail Order',
      'Outpatient',
      'Physician Office',
      'Retail',
      'Specialty',
      'Surgery Center',
      'Other',
    ],
  },
  clientName: 'medigi', // replace with the actual client name of your local env
  clientNameSpace: 'medigi',
};

export const localhost = {
  supplierCompanyName: '',
  logo: {},
  chatlio: {
    widgetId: '',
    widgetTitle: '',
    logo: '',
  },
  auth0: {
    clientId: 'n20sGi7hlL8qprFCaAOwnOHnJ6lN7kzT',
  },
  misc: {
    enableExpeditedShipping: false,
    deliveryComment: null,
    facilityTypes: [],
  },
  clientName: 'mikhail',
  clientNameSpace: 'mikhail',
};

export const supplier1 = {
  supplierCompanyName: 'Eschelon RX',
  logo: {
    small:
      'https://medigi-client-images.s3.us-west-2.amazonaws.com/hydra/echelon/e-logo.svg',
    large:
      'https://medigi-tmp-docs.s3.us-west-2.amazonaws.com/hydra-logos/eschelon-logo.png',
    alt: 'Eschelon RX Logo',
  },
  chatlio: {
    widgetId: '',
    widgetTitle: '',
    logo: '',
  },
  auth0: {
    clientId: 'sZ2oYnLQRCsq0FiojEsvz2v919fuIFME',
  },
  misc: {
    enableExpeditedShipping: false,
    deliveryComment:
      'Orders received M-Th by 12pm CST will ship for next day delivery. All other orders will ship within 48 business hours.',
    facilityTypes: [],
  },
  clientName: 'eschelonrx',
  clientNameSpace: 'eschelonrx',
};

export const ipsenProd = {
  supplierCompanyName: 'Ipsen',
  logo: {
    small:
      'https://medigi-tmp-docs.s3.us-west-2.amazonaws.com/hydra-logos/dysport-icon.png',
    large:
      'https://whitelabel-documents-lower-hq3l56x5.s3.us-west-2.amazonaws.com/medigi-mikhail/Dysport-DIRECT-logo.png',
    alt: 'Dysport Logo',
  },
  chatlio: {
    widgetId: '',
    widgetTitle: 'Dysport Direct Support',
    logo: 'https://medigi-tmp-docs.s3.us-west-2.amazonaws.com/hydra-logos/dysport-icon-square.png',
  },
  auth0: {
    clientId: 'JZuk4aA8PBJdpUL0oYfntYiozj20esJj',
  },
  misc: {
    enableExpeditedShipping: false,
    deliveryComment:
      'Orders received M-Th by 12pm CST will ship for next day delivery.  All other orders will ship within 48 business hours.',
    facilityTypes: [
      'Neurology',
      'Pain Management',
      'Rehabilitation',
      'Other',
    ],
  },
  clientName: 'ipsen',
  clientNameSpace: 'ipsen',
};

export const ipsen = {
  supplierCompanyName: 'Ipsen',
  logo: {
    small:
      'https://medigi-tmp-docs.s3.us-west-2.amazonaws.com/hydra-logos/dysport-icon.png',
    large:
      'https://medigi-tmp-docs.s3.us-west-2.amazonaws.com/hydra-logos/dysport-logo-large.png',
    alt: 'Dysport Logo',
  },
  chatlio: {
    widgetId: '',
    widgetTitle: 'Dysport Direct Support',
    logo: 'https://medigi-tmp-docs.s3.us-west-2.amazonaws.com/hydra-logos/dysport-icon-square.png',
  },
  auth0: {
    clientId: 'n20sGi7hlL8qprFCaAOwnOHnJ6lN7kzT',
  },
  misc: {
    enableExpeditedShipping: false,
    deliveryComment:
      'Orders received M-Th by 12pm CST will ship for next day delivery.  All other orders will ship within 48 business hours.',
    facilityTypes: [
      'Neurology',
      'Pain Management',
      'Rehabilitation',
      'Other',
    ],
  },
  clientName: 'ipsen',
  clientNameSpace: 'ipsen',
};

export const supplier2 = {
  supplierCompanyName: 'Ipsen',
  logo: {
    small:
      'https://medigi-tmp-docs.s3.us-west-2.amazonaws.com/hydra-logos/dysport-icon.png',
    large:
      'https://whitelabel-documents-lower-hq3l56x5.s3.us-west-2.amazonaws.com/medigi-mikhail/Dysport-DIRECT-logo.png',
    alt: 'Dysport Logo',
  },
  chatlio: {
    widgetId: '',
    widgetTitle: 'Dysport Direct Support',
    logo: 'https://medigi-tmp-docs.s3.us-west-2.amazonaws.com/hydra-logos/dysport-icon-square.png',
  },
  auth0: {
    clientId: 'n20sGi7hlL8qprFCaAOwnOHnJ6lN7kzT',
  },
  misc: {
    enableExpeditedShipping: false,
    deliveryComment:
      'Orders received M-Th by 12pm CST will ship for next day delivery.  All other orders will ship within 48 business hours.',
    facilityTypes: [
      'Neurology',
      'Pain Management',
      'Rehabilitation',
      'Pharmacy',
      'Other',
    ],
  },
  clientName: 'supplier2',
  clientNameSpace: 'supplier2',
};

export const supplier3 = {
  supplierCompanyName: 'Hikma',
  logo: {
    small:
      'https://medigi-client-images.s3.us-west-2.amazonaws.com/hydra/hikma/Hik_Logo_SmallUse_Coral_rgb.png',
    large:
      'https://medigi-client-images.s3.us-west-2.amazonaws.com/hydra/hikma/Hik_Logo_Primary_Coral_rgb.png',
    alt: 'Hikma Logo',
  },
  chatlio: {
    widgetId: 'e2221e67-6aa8-4831-7730-d930602c9168',
    widgetTitle: 'Hikma Support',
    logo: 'https://medigi-tmp-docs.s3.us-west-2.amazonaws.com/hydra-logos/Hik_Logo_SmallUse_Coral_rgb_zoomedout.png',
  },
  auth0: {
    clientId: 'Pdw6cXvPzpJjCTIFlaeNFiw6n3Lp26hl',
  },
  misc: {
    enableExpeditedShipping: false,
    deliveryComment:
      'Orders received before 2:00 P.M. EST will be processed the following business day. Once an order has shipped it cannot be cancelled.',
    facilityTypes: [
      'Ambulatory Center',
      'Central Fill',
      'Community Oncology',
      'Compounding',
      'Correctional Facility',
      'Infusion',
      'Inpatient',
      'Long Term Care',
      'Mail Order',
      'Outpatient',
      'Physician Office',
      'Retail',
      'Specialty',
      'Surgery Center',
      'Other',
    ],
  },
  clientName: 'supplier3',
  clientNameSpace: 'supplier3',
};

export const benevStaging = {
  supplierCompanyName: 'Benev',
  logo: {
    small:
      'https://static.wixstatic.com/media/60eb10_40acedb1b848417095c6ec82cd3bc294~mv2.png/v1/crop/x_0,y_1704,w_4500,h_1180/fill/w_410,h_100,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Horizontal-Benev-logo_Black%20.png',
    large:
      'https://static.wixstatic.com/media/60eb10_40acedb1b848417095c6ec82cd3bc294~mv2.png/v1/crop/x_0,y_1704,w_4500,h_1180/fill/w_410,h_100,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Horizontal-Benev-logo_Black%20.png',
    alt: 'Letybo Logo',
  },
  chatlio: {
    widgetId: 'e2221e67-6aa8-4831-7730-d930602c9168',
    widgetTitle: 'Letybo Support',
    logo: 'https://medigi-tmp-docs.s3.us-west-2.amazonaws.com/hydra-logos/Hik_Logo_SmallUse_Coral_rgb_zoomedout.png',
  },
  auth0: {
    clientId: 'W8haTZDIP9gNKUrEcabBJ2R5GuDdXvkn',
  },
  misc: {
    enableExpeditedShipping: false,
    deliveryComment: 'Orders processed by 2:00 PM EST ship within two business days Monday - Thursday via free next day air.',
    facilityTypes: [
      'Dermatology',
      'Aesthetic Clinic',
      'Medical Spa',
      'Physician Office',
      'Other',
    ],
  },
  clientName: 'benev',
  clientNameSpace: 'benev',
  catalogConfig: {
    gridViewThreshold: 1,
  },
};

export const benevDemo = {
  supplierCompanyName: 'Benev',
  logo: {
    small:
      'https://static.wixstatic.com/media/60eb10_40acedb1b848417095c6ec82cd3bc294~mv2.png/v1/crop/x_0,y_1704,w_4500,h_1180/fill/w_410,h_100,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Horizontal-Benev-logo_Black%20.png',
    large:
      'https://static.wixstatic.com/media/60eb10_40acedb1b848417095c6ec82cd3bc294~mv2.png/v1/crop/x_0,y_1704,w_4500,h_1180/fill/w_410,h_100,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Horizontal-Benev-logo_Black%20.png',
    alt: 'Letybo Logo',
  },
  chatlio: {
    widgetId: 'e2221e67-6aa8-4831-7730-d930602c9168',
    widgetTitle: 'Letybo Support',
    logo: 'https://medigi-tmp-docs.s3.us-west-2.amazonaws.com/hydra-logos/Hik_Logo_SmallUse_Coral_rgb_zoomedout.png',
  },
  auth0: {
    clientId: 'PQr3IfIiPK2E8l99FwCBfvw6qknvikP3',
  },
  misc: {
    enableExpeditedShipping: false,
    deliveryComment: 'Orders processed by 2:00 PM EST ship within two business days Monday - Thursday via free next day air.',
    facilityTypes: [
      'Dermatology',
      'Aesthetic Clinic',
      'Medical Spa',
      'Physician Office',
      'Other',
    ],
  },
  clientName: 'benev',
  clientNameSpace: 'benev',
  catalogConfig: {
    gridViewThreshold: 1,
  },
};

export const benevProduction = {
  supplierCompanyName: 'Benev',
  logo: {
    small:
      'https://static.wixstatic.com/media/60eb10_40acedb1b848417095c6ec82cd3bc294~mv2.png/v1/crop/x_0,y_1704,w_4500,h_1180/fill/w_410,h_100,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Horizontal-Benev-logo_Black%20.png',
    large:
      'https://static.wixstatic.com/media/60eb10_40acedb1b848417095c6ec82cd3bc294~mv2.png/v1/crop/x_0,y_1704,w_4500,h_1180/fill/w_410,h_100,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Horizontal-Benev-logo_Black%20.png',
    alt: 'Letybo Logo',
  },
  chatlio: {
    widgetId: '6e752b98-3da4-4d84-7dcf-ece4ef0d8911',
    widgetTitle: 'Letybo Support',
    logo: '',
  },
  auth0: {
    clientId: 'eSnoGiBO1sMg8YH3ywJWfDgzDKSKcEwr',
  },
  misc: {
    enableExpeditedShipping: false,
    deliveryComment: 'Orders processed by 2:00 PM EST ship within two business days Monday - Thursday via free next day air.',
    facilityTypes: [
      'Dermatology',
      'Aesthetic Clinic',
      'Medical Spa',
      'Physician Office',
      'Other',
    ],
  },
  clientName: 'benev',
  clientNameSpace: 'benev',
  catalogConfig: {
    gridViewThreshold: 1,
  },
};

export const hikma = {
  supplierCompanyName: 'Hikma',
  logo: {
    small:
      'https://medigi-client-images.s3.us-west-2.amazonaws.com/hydra/hikma/Hik_Logo_SmallUse_Coral_rgb.png',
    large:
      'https://medigi-client-images.s3.us-west-2.amazonaws.com/hydra/hikma/Hik_Logo_Primary_Coral_rgb.png',
    alt: 'Hikma Logo',
  },
  chatlio: {
    widgetId: 'e2221e67-6aa8-4831-7730-d930602c9168',
    widgetTitle: 'Hikma Support',
    logo: 'https://medigi-tmp-docs.s3.us-west-2.amazonaws.com/hydra-logos/Hik_Logo_SmallUse_Coral_rgb_zoomedout.png',
  },
  auth0: {
    clientId: 'eSnoGiBO1sMg8YH3ywJWfDgzDKSKcEwr',
  },
  misc: {
    enableExpeditedShipping: false,
    deliveryComment:
      'Orders received before 2:00 P.M. EST will be processed the following business day. Once an order has shipped it cannot be cancelled.',
    facilityTypes: [
      'Ambulatory Center',
      'Central Fill',
      'Community Oncology',
      'Compounding',
      'Correctional Facility',
      'Infusion',
      'Inpatient',
      'Long Term Care',
      'Mail Order',
      'Outpatient',
      'Physician Office',
      'Retail',
      'Specialty',
      'Surgery Center',
      'Other',
    ],
  },
  clientName: 'hikma',
  clientNameSpace: 'hikma',
  catalogConfig: {
    buyButtonColor: '#FF5C57',
    gridViewThreshold: 8,
  },
};

export const hikmav2 = {
  supplierCompanyName: 'Hikma',
  logo: {
    small:
      'https://medigi-client-images.s3.us-west-2.amazonaws.com/hydra/hikma/Hik_Logo_SmallUse_Coral_rgb.png',
    large:
      'https://medigi-client-images.s3.us-west-2.amazonaws.com/hydra/hikma/Hik_Logo_Primary_Coral_rgb.png',
    alt: 'Hikma Logo',
  },
  chatlio: {
    widgetId: 'e2221e67-6aa8-4831-7730-d930602c9168',
    widgetTitle: 'Hikma Support',
    logo: 'https://medigi-tmp-docs.s3.us-west-2.amazonaws.com/hydra-logos/Hik_Logo_SmallUse_Coral_rgb_zoomedout.png',
  },
  auth0: {
    clientId: 'Pdw6cXvPzpJjCTIFlaeNFiw6n3Lp26hl',
  },
  misc: {
    enableExpeditedShipping: true,
    deliveryComment:
      'Orders received before 2:00 P.M. EST will be processed the following business day. Once an order has shipped it cannot be cancelled.',
    facilityTypes: [
      'Ambulatory Center',
      'Central Fill',
      'Community Oncology',
      'Compounding',
      'Correctional Facility',
      'Infusion',
      'Inpatient',
      'Long Term Care',
      'Mail Order',
      'Outpatient',
      'Physician Office',
      'Retail',
      'Specialty',
      'Surgery Center',
      'Other',
    ],
  },
  clientName: 'hikmav2',
  clientNameSpace: 'hikmav2',
  catalogConfig: {
    buyButtonColor: '#FF5C57',
    gridViewThreshold: 8,
  },
};

export const supplier4 = {
  supplierCompanyName: 'Chiesi',
  logo: {
    small:
      'https://medigi-tmp-docs.s3.us-west-2.amazonaws.com/hydra-logos/cheisi_icon.png',
    large:
      'https://medigi-tmp-docs.s3.us-west-2.amazonaws.com/hydra-logos/chiesi_logo_blk.png',
    alt: 'Chiesi Logo',
  },
  chatlio: {
    widgetId: '',
    widgetTitle: 'Chiesi Support',
    logo: '',
  },
  auth0: {
    clientId: 'Nxz2J28pFZ0TL7a6G7qZKeKHiXHd1doJ',
  },
  misc: {
    enableExpeditedShipping: false,
    deliveryComment: '',
    facilityTypes: [],
  },
  clientName: 'supplier4',
  clientNameSpace: 'supplier4',
};

export const dysportdirect = {
  supplierCompanyName: 'Ipsen',
  logo: {
    small:
      'https://medigi-tmp-docs.s3.us-west-2.amazonaws.com/hydra-logos/dysport-icon.png',
    large:
      'https://whitelabel-documents-lower-hq3l56x5.s3.us-west-2.amazonaws.com/medigi-mikhail/Dysport-DIRECT-logo.png',
    alt: 'Dysport Logo',
  },
  chatlio: {
    widgetId: '77000286-27b2-4d4c-5eda-e18a2e2a2a19',
    widgetTitle: 'Dysport Direct Support',
    logo: 'https://medigi-tmp-docs.s3.us-west-2.amazonaws.com/hydra-logos/dysport-icon-square.png',
  },
  auth0: {
    clientId: 'JZuk4aA8PBJdpUL0oYfntYiozj20esJj',
  },
  misc: {
    enableExpeditedShipping: false,
    deliveryComment:
      'Orders received M-Th by 12pm CST will ship for next day delivery.  All other orders will ship within 48 business hours.',
    facilityTypes: [
      'Neurology',
      'Pain Management',
      'Rehabilitation',
      'Other',
    ],
  },
  clientName: 'ipsen',
  clientNameSpace: 'ipsen',
};

export const zydusStaging = {
  supplierCompanyName: 'Zydus',
  logo: {
    small: '', // TODO: Get logos
    large: '',
    alt: 'Zydus Logo',
  },
  chatlio: {
    widgetId: '', // TODO: Get widget ID
    widgetTitle: 'Zydus Support',
    logo: '',
  },
  auth0: {
    clientId: 'l8jlkWc6jmpW7AKMQvpfQn8yup2ejnxU',
  },
  misc: {
    enableExpeditedShipping: false,
    deliveryComment: 'Orders processed by 2:00 PM EST ship within two business days Monday - Thursday via free next day air.',
    facilityTypes: [
      'Dermatology',
      'Aesthetic Clinic',
      'Medical Spa',
      'Physician Office',
      'Other',
    ],
  },
  clientName: 'zydus',
  clientNameSpace: 'zydus',
  catalogConfig: {
    gridViewThreshold: 1,
  },
};

export const gprStaging = {
  supplierCompanyName: 'GPR',
  logo: {
    small: 'https://medigi-client-images.s3.us-west-2.amazonaws.com/hydra/gpr/GPR_LOGO_IMAGE.png',
    large: 'https://medigi-client-images.s3.us-west-2.amazonaws.com/hydra/gpr/GPR_Stack_logo_2026.png',
    alt: 'GPR Logo',
  },
  chatlio: {
    widgetId: '',
    widgetTitle: '',
    logo: '',
  },
  auth0: {
    clientId: 'tNrFyyhylPpph2bo6JikaxLgtsF5KjGO',
  },
  misc: {
    enableExpeditedShipping: false,
    deliveryComment: 'Orders generally ship via ground service within 72 hours. You may request expedited shipping at checkout.',
    facilityTypes: [
      'Ambulatory Center',
      'Central Fill',
      'Community Oncology',
      'Compounding',
      'Correctional Facility',
      'Infusion',
      'Inpatient',
      'Long Term Care',
      'Mail Order',
      'Outpatient',
      'Physician Office',
      'Retail',
      'Specialty',
      'Surgery Center',
      'Other',
    ],
  },
  clientName: 'gpr',
  clientNameSpace: 'gpr',
};

export const gprDemo = {
  supplierCompanyName: 'GPR',
  logo: {
    small: 'https://medigi-client-images.s3.us-west-2.amazonaws.com/hydra/gpr/GPR_LOGO_IMAGE.png',
    large: 'https://medigi-client-images.s3.us-west-2.amazonaws.com/hydra/gpr/GPR_Stack_logo_2026.png',
    alt: 'GPR Logo',
  },
  chatlio: {
    widgetId: '',
    widgetTitle: '',
    logo: '',
  },
  auth0: {
    clientId: 'omDpYjwPISvzudDLzExGmbEN0aU2ZduE',
  },
  misc: {
    enableExpeditedShipping: false,
    deliveryComment: 'Orders generally ship via ground service within 72 hours. You may request expedited shipping at checkout.',
    facilityTypes: [],
  },
  clientName: 'gpr',
  clientNameSpace: 'gpr',
};

export const gprProduction = {
  supplierCompanyName: 'GPR',
  logo: {
    small: 'https://medigi-client-images.s3.us-west-2.amazonaws.com/hydra/gpr/GPR_LOGO_IMAGE.png',
    large: 'https://medigi-client-images.s3.us-west-2.amazonaws.com/hydra/gpr/GPR_Stack_logo_2026.png',
    alt: 'GPR Logo',
  },
  chatlio: {
    widgetId: '',
    widgetTitle: '',
    logo: '',
  },
  auth0: {
    clientId: 'F97RYlAyyMVwNpoYRBSqSKa9U6dgqLON',
  },
  misc: {
    enableExpeditedShipping: false,
    deliveryComment: 'Orders generally ship via ground service within 72 hours. You may request expedited shipping at checkout.',
    facilityTypes: [],
  },
  clientName: 'gpr',
  clientNameSpace: 'gpr',
};
